import { NonIdealState, Spinner } from '@blueprintjs/core'
import { DispatchProp } from 'modules/store'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { isEmpty } from '../../../shared'
import * as fromStore from '../../store'
import { LookupData } from './models'

type Props = StateProps & DispatchProp & OwnProps
type StateProps = {
  lookups: LookupData
}

type OwnProps = {
  langCode: string
}

const mapStateToProps = (state: fromStore.CoreState): StateProps => ({
  lookups: fromStore.getLookups(state),
})

const enhance = connect(mapStateToProps)

class Lookups extends Component<Props> {
  render() {
    const { lookups, children } = this.props

    return isEmpty(lookups.locales) ? (
      <NonIdealState title="Please wait...">
        <Spinner />
      </NonIdealState>
    ) : (
      children
    )
  }
  componentDidMount() {
    this.props.dispatch(new fromStore.actions.GetLookupsAction(this.props.langCode))
  }
}

const EnhancedLookups = enhance(Lookups)

export { Lookups }
export default EnhancedLookups



// WEBPACK FOOTER //
// ./src/app/core/components/lookup/lookup.tsx